import { Link } from 'react-router-dom'
import type { siteContent } from '../data/siteContent'
import { useTranslation } from '../context/LanguageContext'

interface FooterProps {
    footer: typeof siteContent.footer;
}

const paymentIcons = [
    {
        name: 'ApplePay',
        element: (
            <svg width="35" height="24" viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="35" height="24" rx="2" fill="white"/>
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M8.3462 8.93296C8.81624 8.97261 9.28628 8.69506 9.58006 8.34316C9.86894 7.98135 10.0599 7.49563 10.0109 7C9.59475 7.01983 9.08064 7.27755 8.78686 7.63936C8.51757 7.95161 8.28745 8.45715 8.3462 8.93296ZM13.9377 15.3167V7.58981H16.8021C18.2807 7.58981 19.3138 8.62072 19.3138 10.1274C19.3138 11.6342 18.2611 12.675 16.7629 12.675H15.1226V15.3167H13.9377ZM10.006 9.02714C9.5919 9.00301 9.21406 9.1532 8.90886 9.27451C8.71246 9.35257 8.54614 9.41868 8.41961 9.41868C8.27762 9.41868 8.10444 9.34904 7.90999 9.27085C7.65521 9.16839 7.36392 9.05125 7.05845 9.05687C6.35829 9.06679 5.70709 9.46825 5.34966 10.1076C4.61522 11.3863 5.1587 13.2796 5.86866 14.3205C6.2163 14.8359 6.63248 15.4009 7.18086 15.3811C7.42211 15.3719 7.59566 15.2974 7.77526 15.2202C7.98203 15.1314 8.19683 15.0391 8.53223 15.0391C8.85599 15.0391 9.0614 15.129 9.25858 15.2152C9.44606 15.2973 9.62611 15.376 9.89339 15.3712C10.4614 15.3613 10.8188 14.8557 11.1664 14.3403C11.5416 13.7871 11.7064 13.2471 11.7314 13.1652L11.7344 13.1557C11.7338 13.1551 11.7291 13.153 11.721 13.1492C11.5956 13.0911 10.637 12.6469 10.6278 11.4557C10.6186 10.4559 11.3881 9.94937 11.5093 9.86963L11.5093 9.86962C11.5166 9.86477 11.5216 9.8615 11.5238 9.85979C11.0342 9.12626 10.2704 9.04696 10.006 9.02714ZM21.478 15.3761C22.2223 15.3761 22.9126 14.9945 23.226 14.3898H23.2505V15.3166H24.3472V11.4706C24.3472 10.3554 23.4659 9.63672 22.1096 9.63672C20.8513 9.63672 19.921 10.3653 19.8867 11.3665H20.9541C21.0423 10.8907 21.478 10.5784 22.0754 10.5784C22.8 10.5784 23.2064 10.9204 23.2064 11.5499V11.9761L21.7277 12.0653C20.3519 12.1496 19.6077 12.7195 19.6077 13.7108C19.6077 14.712 20.3764 15.3761 21.478 15.3761ZM21.7962 14.4592C21.1646 14.4592 20.7631 14.1519 20.7631 13.6811C20.7631 13.1954 21.1499 12.9129 21.8893 12.8683L23.2063 12.784V13.2202C23.2063 13.9438 22.5992 14.4592 21.7962 14.4592ZM27.9851 15.619C27.5102 16.9721 26.9667 17.4181 25.8112 17.4181C25.7231 17.4181 25.4293 17.4082 25.3607 17.3884V16.4616C25.4342 16.4715 25.6153 16.4814 25.7084 16.4814C26.2323 16.4814 26.526 16.2584 26.7072 15.6785L26.8149 15.3365L24.8075 9.71108H26.0462L27.4416 14.2758H27.4661L28.8616 9.71108H30.066L27.9851 15.619ZM15.1225 8.60087H16.4886C17.5168 8.60087 18.1044 9.15598 18.1044 10.1324C18.1044 11.1088 17.5168 11.6688 16.4837 11.6688H15.1225V8.60087Z"
                      fill="black"/>
            </svg>
        ),
    },
    {
        name: 'GooglePay',
        element: (
            <svg width="35" height="24" viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="35" height="24" rx="2" fill="white"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M16.5301 15.7581V12.7371H18.0893C18.7282 12.7371 19.2675 12.5231 19.7071 12.1008L19.8126 11.9938C20.6156 11.1196 20.5629 9.75781 19.7071 8.94905C19.2792 8.52088 18.6931 8.28896 18.0893 8.30085H15.5864V15.7581H16.5301ZM16.5303 11.8213V9.21666H18.1131C18.4531 9.21666 18.7756 9.34749 19.0159 9.58536C19.526 10.0849 19.5377 10.9174 19.0453 11.4348C18.8049 11.6905 18.4649 11.8332 18.1131 11.8213H16.5303ZM24.2147 11.0542C23.8102 10.6796 23.2592 10.4893 22.5617 10.4893C21.6649 10.4893 20.9908 10.8223 20.5453 11.4824L21.3777 12.0116C21.6825 11.5597 22.0987 11.3337 22.6262 11.3337C22.9603 11.3337 23.2827 11.4586 23.5347 11.6846C23.7809 11.8987 23.9216 12.2079 23.9216 12.535V12.755C23.5582 12.5528 23.101 12.4458 22.5383 12.4458C21.8818 12.4458 21.3542 12.6004 20.9615 12.9155C20.5688 13.2307 20.3695 13.647 20.3695 14.1763C20.3578 14.658 20.5629 15.1159 20.9263 15.4251C21.2956 15.7581 21.7645 15.9246 22.3155 15.9246C22.9662 15.9246 23.482 15.6332 23.8747 15.0504H23.9157V15.7581H24.8184V12.6123C24.8184 11.9522 24.6191 11.4289 24.2147 11.0542ZM21.6533 14.8185C21.4599 14.6758 21.3426 14.4438 21.3426 14.1941C21.3426 13.9146 21.4716 13.6827 21.7237 13.4983C21.9816 13.314 22.3041 13.2188 22.6851 13.2188C23.2128 13.2129 23.6231 13.3318 23.9163 13.5697C23.9163 13.974 23.758 14.3249 23.4473 14.6222C23.1659 14.9077 22.7848 15.0682 22.3862 15.0682C22.1223 15.0742 21.8644 14.985 21.6533 14.8185ZM26.8465 18L30 10.6558H28.9743L27.5147 14.319H27.4972L26.0025 10.6558H24.9767L27.0458 15.431L25.8735 18H26.8465Z" fill="#3C4043"/>
                <path d="M13.2721 12.083C13.2721 11.7916 13.2486 11.5002 13.2017 11.2147H9.22174V12.862H11.5019C11.4081 13.3913 11.1033 13.867 10.6578 14.1643V15.2347H12.0177C12.8149 14.4914 13.2721 13.3913 13.2721 12.083Z" fill="#4285F4"/>
                <path d="M9.22192 16.2695C10.3591 16.2695 11.3204 15.8889 12.0179 15.2347L10.658 14.1643C10.277 14.426 9.79049 14.5746 9.22192 14.5746C8.11995 14.5746 7.18796 13.8194 6.85385 12.8085H5.45294V13.9146C6.16805 15.3596 7.62758 16.2695 9.22192 16.2695Z" fill="#34A853"/>
                <path d="M6.85401 12.8085C6.67814 12.2792 6.67814 11.7024 6.85401 11.1672V10.067H5.45288C4.84904 11.2742 4.84904 12.7014 5.45288 13.9086L6.85401 12.8085Z" fill="#FBBC04"/>
                <path d="M9.22192 9.40099C9.82566 9.38909 10.406 9.62102 10.8397 10.0432L12.0472 8.81821C11.2793 8.0927 10.2711 7.69427 9.22192 7.70616C7.62758 7.70616 6.16805 8.62196 5.45294 10.067L6.85385 11.1731C7.18796 10.1562 8.11995 9.40099 9.22192 9.40099Z" fill="#EA4335"/>
            </svg>
        ),
    },
    {
        name: 'Visa',
        element: (
            <svg
                className="icon icon--full-color h-6 w-auto"
                viewBox="0 0 38 24"
                xmlns="http://www.w3.org/2000/svg"
                role="img"
                aria-labelledby="pi-visa"
            >
                <title id="pi-visa">Visa</title>
                <path opacity=".07"
                      d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"/>
                <path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"/>
                <path
                    fill="#142688"
                    d="M28.3 10.1H28c-.4 1-.7 1.5-1 3h1.9c-.3-1.5-.3-2.2-.6-3zm2.9 5.9h-1.7c-.1 0-.1 0-.2-.1l-.2-.9-.1-.2h-2.4c-.1 0-.2 0-.2.2l-.3.9c0 .1-.1.1-.1.1h-2.1l.2-.5L27 8.7c0-.5.3-.7.8-.7h1.5c.1 0 .2 0 .2.2l1.4 6.5c.1.4.2.7.2 1.1.1.1.1.1.1.2zm-13.4-.3l.4-1.8c.1 0 .2.1.2.1.7.3 1.4.5 2.1.4.2 0 .5-.1.7-.2.5-.2.5-.7.1-1.1-.2-.2-.5-.3-.8-.5-.4-.2-.8-.4-1.1-.7-1.2-1-.8-2.4-.1-3.1.6-.4.9-.8 1.7-.8 1.2 0 2.5 0 3.1.2h.1c-.1.6-.2 1.1-.4 1.7-.5-.2-1-.4-1.5-.4-.3 0-.6 0-.9.1-.2 0-.3.1-.4.2-.2.2-.2.5 0 .7l.5.4c.4.2.8.4 1.1.6.5.3 1 .8 1.1 1.4.2.9-.1 1.7-.9 2.3-.5.4-.7.6-1.4.6-1.4 0-2.5.1-3.4-.2-.1.2-.1.2-.2.1zm-3.5.3c.1-.7.1-.7.2-1 .5-2.2 1-4.5 1.4-6.7.1-.2.1-.3.3-.3H18c-.2 1.2-.4 2.1-.7 3.2-.3 1.5-.6 3-1 4.5 0 .2-.1.2-.3.2M5 8.2c0-.1.2-.2.3-.2h3.4c.5 0 .9.3 1 .8l.9 4.4c0 .1 0 .1.1.2 0-.1.1-.1.1-.1l2.1-5.1c-.1-.1 0-.2.1-.2h2.1c0 .1 0 .1-.1.2l-3.1 7.3c-.1.2-.1.3-.2.4-.1.1-.3 0-.5 0H9.7c-.1 0-.2 0-.2-.2L7.9 9.5c-.2-.2-.5-.5-.9-.6-.6-.3-1.7-.5-1.9-.5L5 8.2z"
                />
            </svg>
        ),
    },
    {
        name: 'Mastercard',
        element: (
            <svg
                className="icon icon--full-color h-6 w-auto"
                viewBox="0 0 38 24"
                xmlns="http://www.w3.org/2000/svg"
                role="img"
                aria-labelledby="pi-master"
            >
                <title id="pi-master">Mastercard</title>
                <path opacity=".07"
                      d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"/>
                <path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"/>
                <circle fill="#EB001B" cx="15" cy="12" r="7"/>
                <circle fill="#F79E1B" cx="23" cy="12" r="7"/>
                <path fill="#FF5F00"
                      d="M22 12c0-2.4-1.2-4.5-3-5.7-1.8 1.3-3 3.4-3 5.7s1.2 4.5 3 5.7c1.8-1.2 3-3.3 3-5.7z"/>
            </svg>
        ),
    },
    {
        name: 'MonoPay',
        element: (
            <svg width="35" height="24" viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="35" height="24" rx="2" fill="white"/>
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M7.43012 13.9293V11.8733C7.43012 11.2901 7.10717 11.0132 6.56483 11.0132C6.11388 11.0132 5.72391 11.2725 5.55326 11.5316C5.44357 11.2076 5.16936 11.0132 4.73672 11.0132C4.28577 11.0132 3.8958 11.2842 3.7739 11.4551V11.084H3V13.9293H3.7739V12.0147C3.8897 11.8557 4.11516 11.6789 4.38326 11.6789C4.70014 11.6789 4.82201 11.8674 4.82201 12.1326V13.9293H5.60201V12.0088C5.7117 11.8557 5.93716 11.6789 6.21137 11.6789C6.52825 11.6789 6.65012 11.8674 6.65012 12.1326L6.65015 13.9293H7.43012ZM9.55684 14C8.58795 14 8.00293 13.3166 8.00293 12.5037C8.00293 11.6966 8.58792 11.0133 9.55684 11.0133C10.5318 11.0133 11.1168 11.6966 11.1168 12.5037C11.1168 13.3166 10.5319 14 9.55684 14ZM9.55684 13.3343C10.0382 13.3343 10.3125 12.9514 10.3125 12.5037C10.3125 12.0619 10.0383 11.6789 9.55684 11.6789C9.07541 11.6789 8.80731 12.0619 8.80731 12.5037C8.80731 12.9514 9.07544 13.3343 9.55684 13.3343ZM14.4501 13.9293V11.9205C14.4501 11.3667 14.1393 11.0132 13.4934 11.0132C13.012 11.0132 12.6525 11.2371 12.4636 11.4551V11.084H11.6896V13.9293H12.4636V12.0147C12.5915 11.8439 12.8292 11.6789 13.1339 11.6789C13.4629 11.6789 13.6762 11.8145 13.6762 12.2091V13.9293H14.4501ZM16.5829 14C15.614 14 15.029 13.3166 15.029 12.5037C15.029 11.6966 15.614 11.0133 16.5829 11.0133C17.5579 11.0133 18.1429 11.6966 18.1429 12.5037C18.1429 13.3166 17.5579 14 16.5829 14ZM16.5829 13.3343C17.0643 13.3343 17.3385 12.9514 17.3385 12.5037C17.3385 12.0619 17.0643 11.6789 16.5829 11.6789C16.1015 11.6789 15.8334 12.0619 15.8334 12.5037C15.8334 12.9514 16.1015 13.3343 16.5829 13.3343ZM19.4896 13.0162C19.6176 13.1988 19.904 13.3343 20.1538 13.3343C20.6047 13.3343 20.9033 13.0044 20.9033 12.5096C20.9033 12.0147 20.6047 11.6789 20.1538 11.6789C19.904 11.6789 19.6176 11.8203 19.4896 12.0088V13.0162ZM19.4896 13.9293H18.7157V10H19.4896V11.4492C19.7211 11.1605 20.0502 11.0132 20.3976 11.0132C21.1471 11.0132 21.7016 11.5788 21.7016 12.5096C21.7016 13.458 21.141 14 20.3976 14C20.0441 14 19.7211 13.8468 19.4896 13.564V13.9293ZM24.8277 13.9293H24.0538V13.6348C23.8527 13.8645 23.5054 14 23.1215 14C22.6522 14 22.0977 13.6937 22.0977 13.0574C22.0977 12.3918 22.6523 12.1385 23.1215 12.1385C23.5115 12.1385 23.8588 12.2622 24.0538 12.486V12.1031C24.0538 11.8144 23.7979 11.6259 23.4079 11.6259C23.091 11.6259 22.7985 11.7379 22.5486 11.9617L22.2561 11.461C22.6157 11.1546 23.0788 11.0133 23.5419 11.0133C24.2122 11.0133 24.8277 11.2725 24.8277 12.0913L24.8277 13.9293ZM23.4322 13.4934C23.6821 13.4934 23.9258 13.4109 24.0538 13.2459V12.8925C23.9258 12.7275 23.6821 12.6451 23.4322 12.6451C23.1276 12.6451 22.8777 12.7982 22.8777 13.0751C22.8777 13.3402 23.1275 13.4934 23.4322 13.4934ZM28.356 13.9293V11.9205C28.356 11.3667 28.0452 11.0132 27.3992 11.0132C26.9178 11.0132 26.5583 11.2371 26.3694 11.4551V11.084H25.5955V13.9293H26.3694V12.0147C26.4974 11.8439 26.735 11.6789 27.0397 11.6789C27.3688 11.6789 27.5821 11.8145 27.5821 12.2091V13.9293H28.356ZM32 13.9293L30.7996 12.3741L31.9635 11.084H31.0128L29.8977 12.3505V10H29.1238V13.9293H29.8977V13.1988L30.2511 12.8336L31.0311 13.9293H32Z"
                      fill="black"/>
            </svg>
        ),
    },
]

const InstagramGlyph = () => (
  <svg
    aria-hidden="true"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4.2" />
    <circle cx="17" cy="7" r="1.2" fill="currentColor" stroke="none" />
  </svg>
)

const FacebookGlyph = () => (
  <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M14.5 3c-2.8 0-4.5 1.6-4.5 4.4V10H8v3h2v8h3v-8h3l.5-3H13V7.7c0-.9.3-1.4 1.5-1.4H17V3.1A45.6 45.6 0 0 0 14.5 3Z" />
  </svg>
)

const socialLinks = [
  {
    href: 'https://www.instagram.com/chizh_art',
    label: 'Instagram',
    Icon: InstagramGlyph,
  },
  {
    href: 'https://www.facebook.com/profile.php?id=100046683215826',
    label: 'Facebook',
    Icon: FacebookGlyph,
  },
]

export function Footer({ footer }: FooterProps) {
  const { t } = useTranslation()
  return (
    <footer
      className={`bg-footer-surface border-t border-border mt-20 min-h-[420px] flex flex-col justify-between font-sans [font-family:system-ui,-apple-system,"Segoe UI",sans-serif]`}
      style={{ fontSizeAdjust: 0.52 }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Top Links */}
        <div className="flex flex-wrap justify-center gap-6 mb-8">
          {footer.links.map((link) => {
            const href = link.page.startsWith('/') ? link.page : `/${link.page}`
            return (
              <Link
                key={link.label}
                to={href}
                className="text-sm text-foreground/80 hover:text-foreground transition-colors"
              >
                {t(`footer.link.${link.page}`, link.label)}
              </Link>
            )
          })}
        </div>

        {/* Social Media */}
        <div className="flex justify-center gap-6 mb-8">
          {socialLinks.map(({ href, label, Icon }) => (
            <a
              key={label}
              href={href}
              className="text-foreground/80 hover:text-foreground transition-colors"
              target="_blank"
              rel="noreferrer"
            >
              <Icon />
              <span className="sr-only">{label}</span>
            </a>
          ))}
        </div>

        <p className="text-center text-sm text-foreground/85 mb-8">
          {t(
            'footer.tagline',
            'Custom pet portraits in ink and oil — hand-painted from your photos, shipped worldwide.',
          )}
        </p>
        {/* Payment */}
        <div className="flex flex-col sm:flex-row justify-center items-center gap-3 mb-8">
          <span className="text-sm text-foreground/80">{t('footer.paymentMethods', 'Payment methods:')}</span>
          <div className="flex items-center gap-2">
            {paymentIcons.map((icon) => (
              <span
                key={icon.name}
                className="inline-flex items-center justify-center rounded-md bg-white/70 p-1 shadow-sm"
              >
                {icon.element}
              </span>
            ))}
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center text-sm text-foreground/85">{t('footer.copyright', footer.copyright)}</div>
      </div>
    </footer>
  )
}
